import { actionButtonClicked } from '@wix/bi-logger-members-app-uou/v2';
import type { RoleId } from '@wix/members-domain-ts';

import { ToastSkin } from '../../../constants/toast';
import { getCommonBIEventsData } from '../../../services/bi-event';
import { openModalWithCallback } from '../../../services/modal';
import { maybeNavigateToHomePage } from '../../../services/navigation';
import { Applications } from '../../../services/public-api-store';
import type { ThunkWithArgs } from '../../../types';
import { Origin } from '../../../types';
import { showToast } from '../common';

export const memberBlockMember: ThunkWithArgs<RoleId> =
  (roleId) => async (dispatch, getState, extra) => {
    const {
      compId,
      errorHandlerService,
      wixCodeApi,
      platformAPIs,
      experiments,
      getPublicAPI,
      biLogger,
      flowAPI,
      metaData,
    } = extra;

    const state = getState();
    const { viewed } = state.users;
    const { uid, name: memberName } = viewed;
    const membersAreaAPI = await getPublicAPI(Applications.MembersArea);

    const onConfirm = async () => {
      const { blockMemberService } = extra;

      try {
        await blockMemberService.blockMember(uid, memberName);
      } catch (error) {
        const { message } = errorHandlerService.extractErrorData(error);

        return showToast(dispatch, {
          message,
          skin: ToastSkin.error,
        });
      }

      biLogger?.report(
        actionButtonClicked({
          ...getCommonBIEventsData(flowAPI, state, metaData),
          action_type: 'block_confirm',
          member_chosen: uid,
          formOrigin: Origin.Profile,
          site_member_id: state.users.current?.uid,
        }),
      );

      if (state.site.isWidgetPlugin) {
        return membersAreaAPI?.openBlockedMemberEmptyState();
      }

      maybeNavigateToHomePage(wixCodeApi);

      return showToast(dispatch, {
        message: flowAPI.translations.t(
          'MemberRoles.action_set.block_member.success',
          {
            memberName,
          },
        ),
      });
    };

    openModalWithCallback({
      compId,
      modalType: roleId,
      payload: { memberName: viewed.name },
      platformAPIs,
      wixCodeApi,
      experiments,
      onConfirm,
    });
  };
